var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSlide9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.854,8.353l-13.588,13.622c-.662.661-1.54,1.025-2.475,1.025h-.007c-.938-.002-1.818-.37-2.479-1.035L.148,16.855c-.196-.194-.197-.511-.003-.707.194-.195.511-.198.707-.004l5.16,5.112c.475.479,1.104.741,1.773.743h.005c.668,0,1.295-.26,1.768-.732l13.588-13.621c.195-.196.512-.195.707,0,.196.195.196.512,0,.707Zm-18.12,3.71c.598.603,1.394.936,2.242.937h.007c.846,0,1.641-.33,2.24-.929L20.355,1.852c.194-.196.193-.513-.003-.707s-.513-.193-.707.003l-10.13,10.217c-.409.41-.953.635-1.532.635h-.004c-.581,0-1.126-.229-1.532-.638L1.858,6.651c-.193-.198-.509-.202-.707-.009-.198.192-.202.509-.009.707l4.592,4.714Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSlide9);
export default __webpack_public_path__ + "static/media/check-slide-9.3c463e3a7f84bd974ffed868c297feff.svg";
export { ForwardRef as ReactComponent };